export enum enumInvoiceNextStep {
  INVOICE_SUMMARY,
  ITEM,
}
